module.exports = __webpack_public_path__ + "img/5136483.f2fa77c6.jpg";